module.exports = __webpack_public_path__ + "static/heating-oil-globe-icon-9b25b9718dfdddca6ad78a096b35df0e.svg";